import request from '../utils/request'

export function getLiveList (params) {
  return request({
    url: '/web/live/ByHomeId',
    method: 'GET',
    params
  })
}
export function getLiveInfo (params, id) {
  return request({
    url: `/web/live/info/${id}`,
    method: 'GET',
    params
  })
}
export function getLivelist (params, id) {
  return request({
    url: `/liveproject/live/list`,
    method: 'GET',
    params
  })
}

export function getShareConfig (params, id) {
  return request({
    url: `/web/wx/user/share`,
    method: 'GET',
    params
  })
}

export function wechatParam (params) {
  return request({
    url: `/wx/wechatParam`,
    method: 'GET',
    params
  })
}
export function getAllLiveInfo (data) {
  return request({
    url: `/web/live/user/list`,
    method: 'POST',
    data
  })
}
